export default "../fonts/logo-abitare-co-negative.svg";